import {Pipe, PipeTransform} from "@angular/core";
import {DomSanitizer} from '@angular/platform-browser';
import {generateAvatarURL} from '@cfx-kit/wallet-avatar';
import {gunAvatar} from 'gun-avatar';
import {getGradientColors} from 'web3-avatar';
import {WalletAvatarType} from './wallet-avatar-type';

@Pipe({
    name: 'walletAvatar'
})
export class WalletAvatarPipe implements PipeTransform {

    constructor(
        private sanitizer: DomSanitizer
    ) {}

    public transform(walletAddress: string, type?: WalletAvatarType): any {
        if (!walletAddress) {
            return undefined;
        }

        const result: string = type === WalletAvatarType.GUN_AVATAR
            ? this.getGunAvatar(walletAddress)
            : type === WalletAvatarType.GUN_AVATAR_SQUIRE
                ? this.getGunAvatarSquire(walletAddress)
                : type === WalletAvatarType.WEB_3_AVATAR
                ? this.getWeb3Avatar(walletAddress)
                : type === WalletAvatarType.WALLET_AVATAR
                    ? this.getWalletAvatar(walletAddress)
                    : this.getGunAvatar(walletAddress);

        return this.sanitizer.bypassSecurityTrustResourceUrl(result);
    }

    private getGunAvatar(walletAddress: string): string {
        const trimmedAddr: string = walletAddress?.replace('0x', '');
        const part: string = trimmedAddr
            ? trimmedAddr.length >= 22
                ? trimmedAddr.length < 43
                    ? (trimmedAddr + trimmedAddr).slice(0, 43)
                    : trimmedAddr.slice(0, 43)
                : ''
            : '';

        const fullStr = part
            ? [part, part].join('.')
            : '';

        return gunAvatar({pub: fullStr, dark: true/*, draw: 'squares'*/} as any);
    }

    private getGunAvatarSquire(walletAddress: string): string {
        const trimmedAddr: string = walletAddress?.replace('0x', '');
        const part: string = trimmedAddr
            ? trimmedAddr.length >= 22
                ? trimmedAddr.length < 43
                    ? (trimmedAddr + trimmedAddr).slice(0, 43)
                    : trimmedAddr.slice(0, 43)
                : ''
            : '';

        const fullStr = part
            ? [part, part].join('.')
            : '';

        return gunAvatar({pub: fullStr, dark: true, draw: 'squares'} as any);
    }

    private getWeb3Avatar(walletAddress: string): string {
        const styles = getGradientColors(walletAddress)
            .map((color, index) => `--color-av-${index + 1}:${color};`)
            .join('');

        console.log(styles);

        return styles;
    }

    private getWalletAvatar(walletAddress: string): string {
        return generateAvatarURL(walletAddress);
    }

}
